export function validNumber(value, number) {
    if (!value) {
        return true;
    }
    const leanNumber = value.replace(/(\*|_|\?)/g, '');
    return value ? leanNumber <= number : true;
}
